import {ACTION_TYPES} from "../consts";
import {ActionHandler} from "../../infrastructure/handlers/action-handler";
import {AnalyticsService} from "../../third-party-services/analytics/analytics-service";
import {SearchDisplayEvent} from "../models/search.display-event";

export class SearchDisplayEventHandler extends ActionHandler {
  type = ACTION_TYPES.onSearchDisplay;

  static injectables = [AnalyticsService];

  constructor(analyticsService: AnalyticsService) {
    super();

    this.analyticsService = analyticsService;
  }

  action(params) {
    const clickEvent: SearchDisplayEvent = new SearchDisplayEvent(params?.source);

    this.analyticsService.createEvent(clickEvent);

  }
}
